exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___2fXzT{width:25px;position:relative;cursor:pointer}.index-module__wrapper___2fXzT.index-module__no-map___2hHDl{cursor:default;transform:none!important}.index-module__wrapper___2fXzT p{position:absolute;color:#fff;top:42%;left:50%;transform:translate(-50%,-50%);font-size:15px;font-weight:500}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___2fXzT",
	"no-map": "index-module__no-map___2hHDl"
};